import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'

// Pages
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import AICEODashboardPage from './pages/AICEODashboardPage'
import CustomerSalesPage from './pages/CustomerSalesPage'
import AccountsManagementPage from './pages/AccountsManagementPage'
import InventorySupplyChainPage from './pages/InventorySupplyChainPage'
import ProductCatalogPage from './pages/ProductCatalogPage'
import InventoryManagementPage from './pages/InventoryManagementPage'
import PurchaseOrdersPage from './pages/PurchaseOrdersPage'
import SupplierManagementPage from './pages/SupplierManagementPage'
import StockAlertsPage from './pages/StockAlertsPage'
import ShipmentTrackingPage from './pages/ShipmentTrackingPage'
import SupplyReportsPage from './pages/SupplyReportsPage'
import ProjectManagementPage from './pages/ProjectManagementPage'
import HRPayrollPage from './pages/HRPayrollPage'
import TimeAttendancePage from './pages/TimeAttendancePage'
import PayrollPage from './pages/PayrollPage'
import LeaveManagementPage from './pages/LeaveManagementPage'
import PerformanceReviewsPage from './pages/PerformanceReviewsPage'
import BenefitsPage from './pages/BenefitsPage'
import OnboardingPage from './pages/OnboardingPage'
import HRAnalyticsPage from './pages/HRAnalyticsPage'
import RecoveryCompliancePage from './pages/RecoveryCompliancePage'
import DataLossPreventionPage from './pages/DataLossPreventionPage'
import DataBackupRecoveryPage from './pages/DataBackupRecoveryPage'
import DataRetentionPoliciesPage from './pages/DataRetentionPoliciesPage'
import IncidentResponsePlanPage from './pages/IncidentResponsePlanPage'
import BusinessContinuityPlanPage from './pages/BusinessContinuityPlanPage'
import ComplianceDashboardPage from './pages/ComplianceDashboardPage'
import AccessControlEncryptionPage from './pages/AccessControlEncryptionPage'
import AuditLoggingPage from './pages/AuditLoggingPage'
import MeetingsPage from './pages/MeetingsPage'
import TicketsPage from './pages/TicketsPage'
import TicketDetailPage from './pages/TicketDetailPage'
import ChatPage from './pages/ChatPage'
import KnowledgeBasePage from './pages/KnowledgeBasePage'
import KnowledgeDetailPage from './pages/KnowledgeDetailPage'
import TrainingPage from './pages/TrainingPage'
import CourseDetailPage from './pages/CourseDetailPage'
import CallLogsPage from './pages/CallLogsPage'
import AIConfigPage from './pages/AIConfigPage'
import MultiChannelDashboardPage from './pages/MultiChannelDashboardPage'
import AIControlCenterPage from './pages/AIControlCenterPage'
import SocialMediaManagerPage from './pages/SocialMediaManagerPage'
import AIAutoSocialMediaPage from './pages/AIAutoSocialMediaPage'
import SocialMediaCommentMonitorPage from './pages/SocialMediaCommentMonitorPage'
import MarketingAIMonitorPage from './pages/MarketingAIMonitorPage'
import AIMarketingAssistantPage from './pages/AIMarketingAssistantPage'
import MarketingCostTrackerPage from './pages/MarketingCostTrackerPage'
import FinancialMonitorPage from './pages/FinancialMonitorPage'
import TaxPrepPage from './pages/TaxPrepPage'
import AIFinancialAssistPage from './pages/AIFinancialAssistPage'
import AccountingGeneralLedgerPage from './pages/AccountingGeneralLedgerPage'
import QuickBooksXeroPage from './pages/QuickBooksXeroPage'
import DocumentManagementPage from './pages/DocumentManagementPage'
import DocCollaborationPage from './pages/DocCollaborationPage'
import VersionControlPage from './pages/VersionControlPage'
import DriveIntegrationPage from './pages/DriveIntegrationPage'
import CalendarPage from './pages/CalendarPage'
import MeetingSchedulerPage from './pages/MeetingSchedulerPage'
import WebBrowserPage from './pages/WebBrowserPage'
import NetworkPage from './pages/NetworkPage'
import CloudMonitorPage from './pages/CloudMonitorPage'
import CompanyGrowthMonitorPage from './pages/CompanyGrowthMonitorPage'
import ITILHelpDeskPage from './pages/ITILHelpDeskPage'
import BotMonitorPage from './pages/BotMonitorPage'
import DeveloperStationPage from './pages/DeveloperStationPage'
import EDRPage from './pages/EDRPage'
import AppSecurityPage from './pages/AppSecurityPage'
import GuardbotIntegrationPage from './pages/GuardbotIntegrationPage'
import SandboxAnalysisPage from './pages/SandboxAnalysisPage'
import LiveAuditPage from './pages/LiveAuditPage'
import WriteReportPage from './pages/WriteReportPage'
import AuditHistoryPage from './pages/AuditHistoryPage'
import AuditToolPage from './pages/AuditToolPage'
import PenetrationTestPage from './pages/PenetrationTestPage'
import VulnerabilityAssessmentPage from './pages/VulnerabilityAssessmentPage'
import DarkWebMonitorPage from './pages/DarkWebMonitorPage'
import PhishingSimPage from './pages/PhishingSimPage'
import ToolsShowcasePage from './pages/ToolsShowcasePage'
import IoTDashboardPage from './pages/IoTDashboardPage'
import VisitorManagementPage from './pages/VisitorManagementPage'
import TextNowAIPhoneConfigPage from './pages/TextNowAIPhoneConfigPage'
import CompetitorIntelligencePage from './pages/CompetitorIntelligencePage'
import SentimentAnalysisPage from './pages/SentimentAnalysisPage'
import AnalyticsPage from './pages/AnalyticsPage'
import ComprehensiveAnalyticsDashboard from './pages/ComprehensiveAnalyticsDashboard'
import SettingsPage from './pages/SettingsPage'
import APIIntegrationPage from './pages/APIIntegrationPage'
import IntegrationHubPage from './pages/IntegrationHubPage/IntegrationHubPage'
import BackendAutomationPage from './pages/BackendAutomationPage'
import AISystemAdminConsole from './pages/AISystemAdminConsole'
import AISettingsPage from './pages/AISettingsPage'
import AppAuditPage from './pages/AppAuditPage'
// import BusinessManagementPage from './pages/BusinessManagementPage'
// import IntellectualPropertyPage from './pages/IntellectualPropertyPage'
import AdminAccessControlPanel from './pages/AdminAccessControlPanel'
import EmployeeCollaborationPage from './pages/EmployeeCollaborationPage'
import CybertectionCalendarPage from './pages/CybertectionCalendarPage'
import DeviceProtectionPage from './pages/DeviceProtectionPage'
import NotFoundPage from './pages/NotFoundPage'

// CRM Pages
import CustomersPage from './pages/CustomersPage'
import LeadsPage from './pages/LeadsPage'
import OpportunitiesPage from './pages/OpportunitiesPage'
import ActivitiesPage from './pages/ActivitiesPage'
import ContactsPage from './pages/ContactsPage'
import SalesPipelinePage from './pages/SalesPipelinePage'
import SalesForecastingPage from './pages/SalesForecastingPage'
import SalesReportsAnalyticsPage from './pages/SalesReportsAnalyticsPage'
import SIEMToolPage from './pages/SIEMToolPage'

// Project Management Pages
import ProjectDashboardPage from './pages/ProjectDashboardPage'
import TaskManagementPage from './pages/TaskManagementPage'
import GanttChartsPage from './pages/GanttChartsPage'
import KanbanBoardsPage from './pages/KanbanBoardsPage'
import TeamCollaborationPage from './pages/TeamCollaborationPage'
import TimeTrackingPage from './pages/TimeTrackingPage'
import ProgressTrackingPage from './pages/ProgressTrackingPage'
import ResourcePlanningPage from './pages/ResourcePlanningPage'

// Network Management Pages
import NetworkMonitorPage from './pages/NetworkMonitorPage'
import FirewallManagementPage from './pages/FirewallManagementPage'
import VPNManagementPage from './pages/VPNManagementPage'
import BandwidthMonitorPage from './pages/BandwidthMonitorPage'
import TrafficAnalysisPage from './pages/TrafficAnalysisPage'
import ThreatDetectionPage from './pages/ThreatDetectionPage'
import DNSManagementPage from './pages/DNSManagementPage'
import DeviceConnectivityPage from './pages/DeviceConnectivityPage'

// Layout
import MainLayout from './components/Layout/MainLayout'
import AuthLayout from './components/Layout/AuthLayout'

// Protected Route Component
function ProtectedRoute({ children }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Protected Routes */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/ai-ceo" element={<AICEODashboardPage />} />
        <Route path="/tools-showcase" element={<ToolsShowcasePage />} />

        {/* Customer Sales CRM */}
        <Route path="/customer-sales" element={<CustomerSalesPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/opportunities" element={<OpportunitiesPage />} />
        <Route path="/activities" element={<ActivitiesPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/sales-pipeline" element={<SalesPipelinePage />} />
        <Route path="/sales-forecasting" element={<SalesForecastingPage />} />
        <Route path="/sales-reports" element={<SalesReportsAnalyticsPage />} />

        {/* Accounts & Integrations */}
        <Route path="/accounts" element={<AccountsManagementPage />} />

        {/* Inventory & Supply Chain */}
        <Route path="/inventory-supply-chain" element={<InventorySupplyChainPage />} />
        <Route path="/products" element={<ProductCatalogPage />} />
        <Route path="/inventory" element={<InventoryManagementPage />} />
        <Route path="/purchase-orders" element={<PurchaseOrdersPage />} />
        <Route path="/suppliers" element={<SupplierManagementPage />} />
        <Route path="/stock-alerts" element={<StockAlertsPage />} />
        <Route path="/warehouses" element={<InventoryManagementPage />} />
        <Route path="/shipments" element={<ShipmentTrackingPage />} />
        <Route path="/supply-reports" element={<SupplyReportsPage />} />

        {/* Project & Task Management */}
        <Route path="/project-management" element={<ProjectManagementPage />} />
        <Route path="/projects" element={<ProjectDashboardPage />} />
        <Route path="/tasks" element={<TaskManagementPage />} />
        <Route path="/gantt" element={<GanttChartsPage />} />
        <Route path="/kanban" element={<KanbanBoardsPage />} />
        <Route path="/collaboration" element={<TeamCollaborationPage />} />
        <Route path="/time-tracking" element={<TimeTrackingPage />} />
        <Route path="/progress" element={<ProgressTrackingPage />} />
        <Route path="/resources" element={<ResourcePlanningPage />} />

        {/* HR / Payroll / Employees */}
        <Route path="/hr-payroll" element={<HRPayrollPage />} />
        <Route path="/time-attendance" element={<TimeAttendancePage />} />
        <Route path="/payroll" element={<PayrollPage />} />
        <Route path="/leave-management" element={<LeaveManagementPage />} />
        <Route path="/performance" element={<PerformanceReviewsPage />} />
        <Route path="/benefits" element={<BenefitsPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/hr-analytics" element={<HRAnalyticsPage />} />

        {/* Recovery & Compliance Plan */}
        <Route path="/recovery-compliance" element={<RecoveryCompliancePage />} />

        {/* Recovery & Compliance Tools */}
        <Route path="/dlp" element={<DataLossPreventionPage />} />
        <Route path="/backups" element={<DataBackupRecoveryPage />} />
        <Route path="/retention" element={<DataRetentionPoliciesPage />} />
        <Route path="/incidents" element={<IncidentResponsePlanPage />} />
        <Route path="/continuity" element={<BusinessContinuityPlanPage />} />
        <Route path="/compliance" element={<ComplianceDashboardPage />} />
        <Route path="/encryption" element={<AccessControlEncryptionPage />} />
        <Route path="/audit-logs" element={<AuditLoggingPage />} />

        {/* Calendar */}
        <Route path="/cybertection-calendar" element={<CybertectionCalendarPage />} />

        {/* Meetings & Conferencing */}
        <Route path="/meetings" element={<MeetingsPage />} />

        {/* Tickets */}
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="/tickets/:ticketId" element={<TicketDetailPage />} />

        {/* Chat */}
        <Route path="/chat" element={<ChatPage />} />

        {/* Knowledge Base */}
        <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
        <Route path="/knowledge-base/:docId" element={<KnowledgeDetailPage />} />

        {/* Training */}
        <Route path="/training" element={<TrainingPage />} />
        <Route path="/training/:courseId" element={<CourseDetailPage />} />

        {/* Call Logs */}
        <Route path="/call-logs" element={<CallLogsPage />} />

        {/* TextNow AI Phone Configuration */}
        <Route path="/textnow-phone-config" element={<TextNowAIPhoneConfigPage />} />

        {/* AI Configuration */}
        <Route path="/ai-config" element={<AIConfigPage />} />

        {/* Multi-Channel Dashboard */}
        <Route path="/channels" element={<MultiChannelDashboardPage />} />

        {/* AI Control Center */}
        <Route path="/control-center" element={<AIControlCenterPage />} />

        {/* Social Media Manager */}
        <Route path="/social-media" element={<SocialMediaManagerPage />} />

        {/* AI Auto Social Media */}
        <Route path="/ai-auto-social-media" element={<AIAutoSocialMediaPage />} />

        {/* Social Media Comment Monitor */}
        <Route path="/social-media-comments" element={<SocialMediaCommentMonitorPage />} />

        {/* Marketing AI Monitor */}
        <Route path="/marketing-monitor" element={<MarketingAIMonitorPage />} />

        {/* AI Marketing Assistant */}
        <Route path="/ai-marketing-assistant" element={<AIMarketingAssistantPage />} />

        {/* Marketing Cost Tracker */}
        <Route path="/marketing-cost-tracker" element={<MarketingCostTrackerPage />} />

        {/* Financial Monitor */}
        <Route path="/financial-monitor" element={<FinancialMonitorPage />} />

        {/* Tax Prep */}
        <Route path="/tax-prep" element={<TaxPrepPage />} />

        {/* AI Financial Assist */}
        <Route path="/ai-financial-assist" element={<AIFinancialAssistPage />} />

        {/* Accounting & General Ledger */}
        <Route path="/accounting-general-ledger" element={<AccountingGeneralLedgerPage />} />

        {/* QuickBooks/Xero Integration */}
        <Route path="/quickbooks-xero" element={<QuickBooksXeroPage />} />

        {/* Document Management */}
        <Route path="/document-management" element={<DocumentManagementPage />} />

        {/* Document Collaboration */}
        <Route path="/doc-collaboration" element={<DocCollaborationPage />} />

        {/* Version Control */}
        <Route path="/version-control" element={<VersionControlPage />} />

        {/* Drive Integration */}
        <Route path="/drive-integration" element={<DriveIntegrationPage />} />

        {/* Calendar */}
        <Route path="/calendar" element={<CalendarPage />} />

        {/* Meeting Scheduler */}
        <Route path="/meeting-scheduler" element={<MeetingSchedulerPage />} />

        {/* Web Browser */}
        <Route path="/web-browser" element={<WebBrowserPage />} />

        {/* Network */}
        <Route path="/network" element={<NetworkPage />} />
        <Route path="/network-monitor" element={<NetworkMonitorPage />} />
        <Route path="/firewall-management" element={<FirewallManagementPage />} />
        <Route path="/vpn-management" element={<VPNManagementPage />} />
        <Route path="/bandwidth-monitor" element={<BandwidthMonitorPage />} />
        <Route path="/traffic-analysis" element={<TrafficAnalysisPage />} />
        <Route path="/threat-detection" element={<ThreatDetectionPage />} />
        <Route path="/dns-management" element={<DNSManagementPage />} />
        <Route path="/device-connectivity" element={<DeviceConnectivityPage />} />

        {/* Cloud Monitor */}
        <Route path="/cloud-monitor" element={<CloudMonitorPage />} />

        {/* Company Growth Monitor */}
        <Route path="/company-growth" element={<CompanyGrowthMonitorPage />} />

        {/* ITIL Help Desk */}
        <Route path="/itil-helpdesk" element={<ITILHelpDeskPage />} />

        {/* Training Center Bot Monitors */}
        <Route path="/bots/:botId" element={<BotMonitorPage />} />

        {/* Developer Station */}
        <Route path="/developer-station" element={<DeveloperStationPage />} />

        {/* Security Tools */}
        <Route path="/edr" element={<EDRPage />} />
        <Route path="/app-security" element={<AppSecurityPage />} />
        <Route path="/guardbot-integration" element={<GuardbotIntegrationPage />} />
        <Route path="/sandbox-analysis" element={<SandboxAnalysisPage />} />

        {/* Auditor */}
        <Route path="/live-audit" element={<LiveAuditPage />} />
        <Route path="/write-report" element={<WriteReportPage />} />
        <Route path="/audit-history" element={<AuditHistoryPage />} />
        <Route path="/audit-tool" element={<AuditToolPage />} />
        <Route path="/penetration-test" element={<PenetrationTestPage />} />
        <Route path="/vulnerability-assessment" element={<VulnerabilityAssessmentPage />} />
        <Route path="/siem-tool" element={<SIEMToolPage />} />
        <Route path="/dark-web-monitor" element={<DarkWebMonitorPage />} />
        <Route path="/phishing-sim" element={<PhishingSimPage />} />

        {/* IoT */}
        <Route path="/iot" element={<IoTDashboardPage />} />

        {/* Visitor Management */}
        <Route path="/visitor-management" element={<VisitorManagementPage />} />

        {/* Competitor Intelligence */}
        <Route path="/competitor-intelligence" element={<CompetitorIntelligencePage />} />

        {/* Sentiment Analysis */}
        <Route path="/sentiment-analysis" element={<SentimentAnalysisPage />} />

        {/* Analytics */}
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/comprehensive-analytics" element={<ComprehensiveAnalyticsDashboard />} />

        {/* Settings */}
        <Route path="/settings" element={<SettingsPage />} />

        {/* API Integration */}
        <Route path="/api-integration" element={<APIIntegrationPage />} />
        <Route path="/integration-hub" element={<IntegrationHubPage />} />

        {/* Backend Automation */}
        <Route path="/backend-automation" element={<BackendAutomationPage />} />

        {/* AI System Admin Console */}
        <Route path="/ai-system-admin" element={<AISystemAdminConsole />} />

        {/* AI Settings & Control */}
        <Route path="/ai-settings" element={<AISettingsPage />} />

        {/* App Audit */}
        <Route path="/app-audit" element={<AppAuditPage />} />

        {/* Business Management - DISABLED */}
        {/* <Route path="/business-management" element={<BusinessManagementPage />} /> */}

        {/* Intellectual Property Management - DISABLED */}
        {/* <Route path="/intellectual-property" element={<IntellectualPropertyPage />} /> */}

        {/* Employee Management */}
        <Route path="/employees" element={<EmployeeCollaborationPage />} />

        {/* Device Protection */}
        <Route path="/device-protection" element={<DeviceProtectionPage />} />

        {/* Admin Access Control */}
        <Route path="/admin-access-control" element={<AdminAccessControlPanel />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
